import { useEffect, useState } from "react";
import { styled } from "@mui/material";
import clsx from "clsx";
import TextFieldCustom from "../TextFieldCustom/TextFieldCustom";
import NormalText from "../Typography/NormalText";

const TextFieldStyled = styled(TextFieldCustom)({
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
  "& .time-unit": {
    fontSize: "0.75rem",
    lineHeight: 1.66,
    textAlign: "left",
    letterSpacing: "0.03333em",
    color: "rgba(0,0,0,0.6)",
    marginLeft: "4px",
  },
});

const DurationInput = ({
  units = "minutes",
  onChange,
  isViewMode,
  value,
  defaultValue,
  className,
  classNames = {}, //expected values: timeUnit,
  ...fieldProps
}) => {
  const [numberValue, setNumberValue] = useState(Number(defaultValue));

  const handleChange = (e) => {
    const duration = parseInt(e.target.value);

    setNumberValue(duration);
    onChange?.(duration);
  };

  const handleBlur = () => {
    if (Number.isNaN(numberValue)) {
      if (value) {
        onChange?.(0);
      } else {
        setNumberValue(0);
      }
    }
  };

  useEffect(() => {
    setNumberValue(value);
  }, [value]);

  return (
    <TextFieldStyled
      type="number"
      onChange={handleChange}
      isViewMode={isViewMode}
      onBlur={handleBlur}
      value={numberValue}
      defaultValue={defaultValue}
      className={className}
      slotProps={{
        htmlInput: { pattern: "[0-9]" },
        input: {
          endAdornment: (
            <NormalText
              className={clsx("time-unit", classNames.timeUnit)}
              text={units}
            />
          ),
        },
      }}
      {...fieldProps}
    />
  );
};

export default DurationInput;
